<div class="bp-modal mod-md">
  <bp-modal-header [title]="'asset_detail_you_own_info_dialog_title' | translate">
    <a right (click)="close()" class="large-weight" (keydown.enter)="close()" [tabindex]="0">
      {{ "close" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body text-center">
    <div class="text extra-space"> {{ "asset_detail_you_own_info_dialog_subtitle" | translate }}</div>
    @if (isMarginTradingEligible$ | async) {
      <div class="text"> {{ "asset_detail_margin_trading_dialog_subtitle" | translate }}</div>
    }
    <hr />
    <div class="headline">{{ "asset_detail_you_own_info_total_return" | translate }}</div>
    <div class="text"> {{ "asset_detail_you_own_info_total_return_description" | translate }}</div>
    <hr />
    <div class="headline">{{ "asset_detail_you_own_info_one_day_return" | translate }}</div>
    <div class="text"> {{ "asset_detail_you_own_info_one_day_return_description" | translate }}</div>
    <hr />
    <div class="headline">{{ "asset_detail_you_own_info_average_buy_price" | translate }}</div>
    <div class="text">{{
      data.getCurrencyType() === leverageType
      ? ("asset_detail_you_own_info_average_buy_price_description_leverage" | translate)
      : ("asset_detail_you_own_info_average_buy_price_description_all" | translate)
    }}</div>
    @if (data.getCurrencyType() === cryptoType) {
      <div class="text">
        {{ "asset_detail_you_own_info_average_buy_price_description_crypto" | translate }}
      </div>
    }
    @if (data.getCurrencyType() === leverageType) {
      <div>
        <hr />
        <div class="headline">{{ "tradable_you_own_position" | translate }}</div>
        <div class="text">
          {{
          ((cfdEnabled$ | async)
          ? "cfd_asset_detail_you_own_info_current_position_description"
          : "asset_detail_you_own_info_current_position_description"
          ) | translate
          }}
        </div>
      </div>
    }
  </div>
</div>
